import { DayHeaderContentArg } from '@fullcalendar/core';
import Typography from '@mui/material/Typography';
import { format } from 'date-fns';
import React from 'react';

import * as Styled from './date-header.style';

export const DateHeader: React.FC<DayHeaderContentArg> = ({ date }) => {
  // fullcalendar gives utc date, so we need to add the timezone offset to display the correct date for the user
  const _date = new Date(date.getTime() + date.getTimezoneOffset() * 60_000);

  return (
    <Styled.DateHeaderContainer>
      <Typography variant="buttonSmall" component="span">
        {format(_date, 'EEEEEE')}
      </Typography>
    </Styled.DateHeaderContainer>
  );
};
